import React from 'react'

const PrevTrack = props => (
  <svg width="10px" height="12px" viewBox="0 0 10 12" style={{ flexShrink: 0 }} {...props}>
    <polygon fill="#FAFBFB" points="10,0 2,4.8 2,0 0,0 0,12 2,12 2,7.2 10,12" />
  </svg>
)

export default PrevTrack
